function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var paintPoint = {},
  lcpPoint = null,
  paintCount = 0,
  paintReported = false;
function savePaintTimings(entry, etracker, config) {
  var name = entry.name,
    startTime = entry.startTime;
  var pointMap = {
    'first-paint': 'p1',
    'first-contentful-paint': 'p2'
  };
  if (!pointMap[name] || paintPoint[pointMap[name]]) {
    return;
  }
  paintPoint[pointMap[name]] = startTime;
  paintCount++;

  // 不支持LCP，等待FP和FCP都触发了，一起上报一条
  if (!window.LargestContentfulPaint && paintCount === 2) {
    sendPaintTimings(etracker);
  }
}
function sendPaintTimings(etracker, config) {
  lcpPoint && parseLCPTimings(lcpPoint);
  if (paintCount || lcpPoint) {
    !paintReported && etracker.log('painttiming', paintPoint);
    paintReported = true;
  }
}
function sendUserTimings(entry, etracker) {
  etracker.log('usertiming', {
    p1: entry.startTime,
    p2: entry.duration,
    p3: entry.entryType,
    p4: entry.name,
    p5: entry.detail,
    c1: entry.c1,
    c2: entry.c2,
    c3: entry.c3,
    c4: entry.c4,
    c5: entry.c5,
    c6: entry.c6,
    c7: entry.c7,
    c8: entry.c8,
    c9: entry.c9,
    c10: entry.c10
  });
}
function saveLCPTimings(item) {
  lcpPoint = item;
}
function parseLCPTimings(item) {
  paintPoint.p3 = item.startTime;
  paintPoint.p4 = item.element && item.element.tagName;
  paintPoint.p5 = item.url;
}
function sendNavigationTimings(timing, etracker) {
  etracker.log('navigationtiming', {
    p1: timing.unloadEventStart,
    p2: timing.unloadEventEnd,
    p3: timing.redirectStart,
    p4: timing.redirectEnd,
    p5: timing.fetchStart,
    p6: timing.domainLookupStart,
    p7: timing.domainLookupEnd,
    p8: timing.connectStart,
    p9: timing.connectEnd,
    p10: timing.secureConnectionStart,
    p11: timing.requestStart,
    p12: timing.responseStart,
    p13: timing.responseEnd,
    p14: timing.domLoading,
    p15: timing.domInteractive,
    p16: timing.domContentLoadedEventStart,
    p17: timing.domContentLoadedEventEnd,
    p18: timing.domComplete,
    p19: timing.loadEventStart,
    p20: timing.loadEventEnd
  });
}

function assign$1(o1, o2) {
  for (var i in o2) {
    o1[i] = o2[i];
  }
  return o1;
}
var initStartTime = new Date().getTime();
function getCurrentTime() {
  if (window.performance && window.performance.now) {
    return window.performance.now();
  } else if (window.performance && window.performance.timing) {
    return new Date().getTime() - window.performance.timing.navigationStart;
  } else {
    return new Date().getTime() - initStartTime;
  }
}
function initUserTiming(etracker, config) {
  var markList = [];
  var findMark = function findMark(name) {
    return markList.concat([]).reverse().find(function (item) {
      return item.name === name + '';
    });
  };
  var mark = function mark(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
      var entry = assign$1({
        name: name + '',
        entryType: 'mark',
        startTime: getCurrentTime(),
        duration: 0
      }, options);
      markList.push(entry);
      sendUserTimings(entry, etracker);
      return entry;
    } catch (e) {
      console.error('Failed to execute "mark" on "Performance": ', e);
    }
  };
  var markWithEntry = function markWithEntry(entry) {
    sendUserTimings(assign$1({
      entryType: 'mark',
      duration: 0
    }, entry), etracker);
    return entry;
  };
  var measure = function measure(name, startMarkName, endMarkName) {
    try {
      var entry;
      if (_typeof(startMarkName) === 'object') {
        if (startMarkName.start === undefined && startMarkName.end == undefined) {
          throw new Error('at least one of its "start" or "end" properties must be persent');
        }
        if (startMarkName.start !== undefined && startMarkName.end !== undefined && startMarkName.duration !== undefined) {
          throw new Error('it mest not have all of its "start", "duration", "end" properties defined');
        }
        var startTime = typeof startMarkName.start === 'number' ? startMarkName.start : typeof startMarkName.start === 'string' ? findMark(startMarkName.start).startTime : null;
        var endTime = typeof startMarkName.end === 'number' ? startMarkName.end : typeof startMarkName.end === 'string' ? findMark(startMarkName.end).startTime : null;
        var duration = startMarkName.duration;
        if (typeof duration !== 'number') {
          duration = (endTime || getCurrentTime()) - (startTime || 0);
        }
        if (typeof startTime !== 'number') {
          startTime = endTime - duration;
        }
        entry = assign$1(assign$1({}, startMarkName), {
          name: name + '',
          entryType: 'measure',
          startTime: startTime,
          duration: duration
        });
      } else {
        var startMark = typeof startMarkName === 'undefined' ? null : findMark(startMarkName),
          endMark = typeof endMarkName === 'undefined' ? null : findMark(endMarkName);
        startMark = startMark || {
          startTime: 0
        };
        entry = {
          name: name + '',
          entryType: 'measure',
          startTime: startMark.startTime,
          duration: (endMark && endMark.startTime || getCurrentTime()) - startMark.startTime
        };
      }
      sendUserTimings(entry, etracker);
      return entry;
    } catch (ex) {
      console.error('Failed to execute "measure" on "Performance"', ex);
    }
  };
  var measureWithEntry = function measureWithEntry(entry) {
    sendUserTimings(assign$1({
      entryType: 'measure'
    }, entry), etracker);
    return entry;
  };
  return {
    mark: mark,
    measure: measure,
    markWithEntry: markWithEntry,
    measureWithEntry: measureWithEntry
  };
}

// navigation timing
// 通过异步引入该脚本，并且资源已经下载完，这时会走第一种情况，可以拿到loadEventEnd
// 但是，如果同步引入，或者异步引入时资源未下载完，会走第二种情况，此时没有loadEventEnd
function onLoad(callback) {
  if (document.readyState === 'complete') {
    setTimeout(callback);
  } else {
    window.addEventListener("load", function () {
      return setTimeout(callback);
    });
  }
}

// performance.timing
var getPerformanceTiming = function getPerformanceTiming() {
  if (window.performance && window.performance.timing && window.performance.timing.loadEventEnd > 0) {
    var timing = {};
    for (var i in performance.timing) {
      if (typeof performance.timing[i] === "number" && performance.timing[i] > 0) {
        timing[i] = Math.max(performance.timing[i] - performance.timing.navigationStart, 0);
      }
    }
    return timing;
  }
};

// 支持lcp，则在页面隐藏/卸载时一起上报fp、fcp、lcp的数据
var watchPageHideOnce = function watchPageHideOnce(callback) {
  function pageHiddenHandler(e) {
    if (document.hidden) {
      callback();
      document.removeEventListener('visibilitychange', pageHiddenHandler);
      window.removeEventListener('beforeunload', beforeunloadHandler);
    }
  }
  function beforeunloadHandler() {
    callback();
    document.removeEventListener('visibilitychange', pageHiddenHandler);
  }
  window.addEventListener('beforeunload', beforeunloadHandler);
  document.addEventListener('visibilitychange', pageHiddenHandler);
};

// paint timing, user timing, element timing
var initPerformanceObserver = function initPerformanceObserver(etracker, config) {
  if (!window.PerformanceObserver) {
    return;
  }
  var toObserveList = [];
  var enableUserTimingObserve = config.plugin_perf_enableUserTimingObserve;
  if (enableUserTimingObserve) {
    if (window.PerformanceMark) {
      toObserveList.push('mark');
    }
    if (window.PerformanceMeasure) {
      toObserveList.push('measure');
    }
  }
  if (window.PerformancePaintTiming) {
    toObserveList.push('paint');
  }
  if (window.LargestContentfulPaint) {
    toObserveList.push('largest-contentful-paint');
  }
  try {
    for (var i = 0; i < toObserveList.length; i++) {
      var entryType = toObserveList[i];
      var observer = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (item) {
          switch (item.entryType) {
            case "paint":
              savePaintTimings(item, etracker, config);
              break;
            case "mark":
            case "measure":
              sendUserTimings(item, etracker, config);
              break;
            case "largest-contentful-paint":
              saveLCPTimings(item);
              break;
          }
        });
      });
      if (entryType === 'largest-contentful-paint') {
        // 有用户行为时，上报fp、fcp、lcp的数据，并停止监听，以解决超大异常值问题
        ['keydown', 'click'].forEach(function (type) {
          addEventListener(type, function () {
            observer.disconnect();
            sendPaintTimings(etracker, config);
          }, {
            once: true,
            capture: true
          });
        });

        // 页面隐藏时，上报fp、fcp、lcp的数据，并停止监听
        watchPageHideOnce(function () {
          observer.disconnect();
          sendPaintTimings(etracker, config);
        });
      }

      // Safari 对于 mark、measure不支持type 只支持entryType，对于PaintTiming、ElementTiming、LCP都不支持
      try {
        observer.observe({
          type: entryType,
          buffered: true
        });
      } catch (e) {
        // 不支持type时，直接observe所有entryTypes，并跳出循环
        observer.observe({
          entryTypes: toObserveList
        });
        break;
      }
    }
  } catch (e) {}
};
function assign(o1, o2) {
  for (var i in o2) {
    o1[i] = o2[i];
  }
  return o1;
}
function EtrackerPluginPerf(etracker) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  config = assign(assign({}, etracker.getConfig('plugin_perf')), config);
  var _initUserTiming = initUserTiming(etracker),
    mark = _initUserTiming.mark,
    measure = _initUserTiming.measure,
    markWithEntry = _initUserTiming.markWithEntry,
    measureWithEntry = _initUserTiming.measureWithEntry;
  onLoad(function () {
    // navigation timing report
    var timing = getPerformanceTiming();
    if (timing && timing.responseEnd >= timing.responseStart && timing.loadEventEnd >= timing.responseEnd) {
      sendNavigationTimings(timing, etracker);
    }
  });
  initPerformanceObserver(etracker, config);
  return {
    mark: mark,
    measure: measure,
    markwithEntry: markWithEntry,
    measureWithEntry: measureWithEntry
  };
}

export { EtrackerPluginPerf as default };
